import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { NutritionAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface NutritionActionFormGroup {
	amountGiven: FormControl<UnitQuantity | null>;
	amountEaten: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-nutrition-action-controls',
    templateUrl: './nutrition-action-controls.component.html',
    styleUrls: ['../../../common.scss', './nutrition-action-controls.component.scss'],
    imports: [ReactiveFormsModule, CommonActionControlsComponent, ActionFormComponent, UnitQuantityControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NutritionActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: NutritionAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as NutritionAction;
	}

	@Input() form!: FormGroup<NutritionActionFormGroup>;
	@Input() item!: Row | null;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('amountGiven', this.formBuilder.control(this.action?.amountGiven ?? null));
		this.form.addControl('amountEaten', this.formBuilder.control(this.action?.amountEaten ?? null));
	}
}